import { createContext, useReducer } from "react";


export const UserContext = createContext({});
const initialState = {
    user: null,
    loading: true,
    error: "",
};

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_USER":
            return {
                ...state,
                user: action.payload,
                error: "",
              };
        case "SET_USER_ERROR":
            return {
                ...state,
                error: action.payload,
            };
        case "REMOVE_USER":
            return {
                ...state,
                user: null,
            };
        default:
            return state;
    }
};

export const UserContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    async function loginUser(user) {
        try {
            dispatch({ type: "SET_USER", payload: user });
            sessionStorage.setItem("6ec0b1d10ed3c71aac779ff07fa8dbe7d83aa780", JSON.stringify(user));
        } catch (error) {
            dispatch({  type: "SET_USER_ERROR", payload: error.message });
        }
    }

    async function logoutUser() {
        console.log("clic logout")
        try {
            sessionStorage.removeItem("6ec0b1d10ed3c71aac779ff07fa8dbe7d83aa780");
            dispatch({ type: "REMOVE_USER" });
        } catch (error) {
            console.log(error);
        }
    }

    async function getUser() {
        try {
            const user = sessionStorage.getItem("6ec0b1d10ed3c71aac779ff07fa8dbe7d83aa780");
            if (user !== null) {
                dispatch({ type: "SET_USER", payload: JSON.parse(user) })
            }
        } catch (error) {
            
        }
    }

    async function setUser(user) {
        try {
            console.log("setUser", user);
            sessionStorage.removeItem("6ec0b1d10ed3c71aac779ff07fa8dbe7d83aa780");
            sessionStorage.setItem("6ec0b1d10ed3c71aac779ff07fa8dbe7d83aa780", JSON.stringify(user));
            dispatch({ type: "SET_USER", payload: JSON.parse(user) })
        } catch (error) {
            
        }
    }

    return (
        <UserContext.Provider 
            value={{ ...state, loginUser, logoutUser, getUser, setUser }} >
            {children}
        </UserContext.Provider>
    )
};

export default UserContext